(function () {
  'use strict';

  /* @ngdoc object
   * @name crewViolations
   * @description
   *
   */
  angular
    .module('consecutiveDayFlightAndEarlyMorningDeparture', [
      'ui.router'
    ]);
}());
